/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/

/**
 * main.js
 */

/*━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━*/
/**
 * Import.
 */
import { modules } from "./module/modules";

/**
 * iPhoneブラウザバック時リロード処理
 */
window.onpageshow = function (evt) {
	if (evt.persisted) {
		location.reload();
	}
};

/**
 * Passive Event Listener.
 */
document.addEventListener("touchstart", function () {}, { passive: true });

/**
 * 表示画面高さ取得
 */
const setFillHeight = () => {
	const vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty("--vh", `${vh}px`);
};
window.addEventListener("resize", setFillHeight);
setFillHeight();

/**
 * Run.
 */
modules();

// scroll-hint（対象があるときだけ初期化）
import ScrollHint from "scroll-hint";
if (document.querySelector(".js-scrollable")) {
	new ScrollHint(".js-scrollable", {
		scrollHintIconClass: "scroll-hint-icon-svg",
	});
}
